import { render, staticRenderFns } from "./ConTacto.vue?vue&type=template&id=5b4673ce&scoped=true"
import script from "./ConTacto.vue?vue&type=script&lang=js"
export * from "./ConTacto.vue?vue&type=script&lang=js"
import style0 from "./ConTacto.vue?vue&type=style&index=0&id=5b4673ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4673ce",
  null
  
)

export default component.exports